import React from 'react'

// 扩展业务站点注入的行为
export function withExtendsPageConfig(pageConfig) {
  return function wrap(Component) {
    return class extends React.PureComponent {
      static displayName = `fwPageWithExtendsPageConfig(${
        Component.displayName || Component.name || 'Component'
      })`

      static async getInitialProps(ctx) {
        let pageInitialProps = {}
        if (Component.getInitialProps) {
          pageInitialProps = await Component.getInitialProps(ctx)
        }
        return pageInitialProps
      }

      constructor(props) {
        super(props)
        const { globalConfig } = props.ctx.__AL_EX_internalScope

        if (globalConfig.extendsPageConfig) {
          this.targetComponent = globalConfig.extendsPageConfig(
            pageConfig,
            Component
          )
        } else {
          this.targetComponent = Component
        }
      }

      render() {
        const TargetComponent = this.targetComponent
        return <TargetComponent {...this.props} />
      }
    }
  }
}
